module.exports = __webpack_public_path__ + "img/icono_mascotas.62a6ebfa.png";